<script>
import { mapActions } from 'vuex';
import { convertImageCoordsToRadiants } from '@/utils/coords';
import { imageUrl } from '@/utils/urls';

export default {
  name: 'MarzipanoFloater',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      floater: undefined,
    };
  },
  created() {
    this.switchScene = this.switchScene.bind(this);
  },
  mounted() {
    this.floater.domElement().addEventListener('click', this.switchScene);
  },
  render() {
    if (!this.floater) {
      this.floater = this.createFloater();
    }

    return undefined;
  },
  methods: {
    ...mapActions('nativePanorama', ['switchHotspot']),
    createFloater() {
      return this.$parent.scene
        .hotspotContainer()
        .createHotspot(this.createElement(), convertImageCoordsToRadiants(this.data), this.data.options);
    },
    createElement() {
      return Object.assign(document.createElement('img'), {
        className: 'marzipano-floater',
        src: imageUrl('img/marzipano/floater.svg'),
      });
    },
    switchScene(event) {
      event.stopPropagation();
      event.preventDefault();

      this.switchHotspot({ id: this.data.link_id, yaw: this.$parent.scene.view().yaw() });
    },
  },
};

</script>

<style lang="scss">
$floater-size: 46px;

.marzipano-floater {
  width: $floater-size;
  height: $floater-size;
  cursor: pointer;
}
</style>
